import * as seoSitemapEntries from '@wix/auto_sdk_seo_seo-sitemap-entries';
import * as seoTags from '@wix/auto_sdk_seo_seo-tags';
import * as robotsTxt from '@wix/auto_sdk_seo_robots-txt';

export { seoSitemapEntries, seoTags, robotsTxt };
